import { AlertCard } from "@dash/page";
import { useTheme } from "@emotion/react";
import { MdWarningAmber } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";

import { Customer } from "./OrderDraftPageContent";

type Props = {
  customer: Customer;
};

export const CustomerAlert = ({ customer }: Props) => {
  return (
    <Link to={`/crm/customers/id/${customer.uuid}`}>
      <AlertCard title={customer.name}>{customer.alert}</AlertCard>
    </Link>
  );
};
